import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { all, delay, put, takeLatest } from 'redux-saga/effects';
import env from '../../config/env';
import * as checkoutService from '../../services/checkout.service';
import * as orderService from '../../services/order.service';
import * as service from '../../services/orderPlacement.service';
import { BILLING_TYPE, ORDER_STATUS } from '../../utils/constants';
import {
    // getActiveOrders,
    // getMenuDetailsRequest,
    getMenuDetailsSuccess,
    payOrderRequest,
    setCustomerOrder,
    setFeedback,
    setTokenCode,
    setOrderPaymentData,
    setShowOrder,
    // updateShowMenuCard,
    setOrderDetails,
    getCurrentOrderRequest,
    setCurrentOrder,
    setClassicMenuData,
    resetStateRequest,
    setIsLoading,
    setUserRatings,
    setOrderSuccessAnimation,
    setFoodCourtHotelData
    // subscribeNotificationRequest
    // setAdditionalActions
} from '../slice';
import {
    GET_CURRENT_ORDER_REQUEST,
    GET_MENU_DETAIL_REQUEST,
    NOTIFY_MANAGERS_REQUEST,
    // PAY_FAILURE_REQUEST,
    PAY_ORDER_REQUEST,
    PAY_SUCCESS_REQUEST,
    PLACE_ORDER_REQUEST,
    SEND_FEEDBACK_REQUEST
} from '../types';

function* getMenuDetailsRequestSaga(action) {
    try {
        const data = action.payload;
        const res = yield service.getMenuDetails(data);

        const hotelIds = Object.keys(res.data);
        if (hotelIds.length) {
            const ratings = yield service.getRatingsData({ hotelIds });
            yield put(setUserRatings(ratings));
        }

        if (res.classic) {
            yield put(setClassicMenuData(res));
            localStorage.setItem('menu-type', 'classic');
        } else {
            yield put(getMenuDetailsSuccess(res));
            localStorage.setItem('menu-type', 'app');
        }
    } catch (error) {
        console.error('Failed to fetch menu card details', error);
        toast.error(`Failed to fetch menu card details ${error.message}`);
    }
}

function* placeOrderRequestSaga(action) {
    try {
        const { data } = action.payload;
        // const hotelId = data.hotelId;
        const { foodCourtId, ...payload } = data;
        const res = yield service.placeOrder(payload);
        if (res.type === BILLING_TYPE[0].value) {
            yield put(payOrderRequest({
                hotelIds: res.hotelIds,
                customerId: res.customerId,
                type: res.type,
                tableId: payload.tableId,
                hotelName: res.hotelName,
                foodCourtId: payload.isFoodCourt ? foodCourtId : null,
                tokenCode: res.tokenCode,
                tokenId: res.tokenId,
                new: res.new
                // frameCode: res.frameCode
            }));
        } else {
            yield put(setShowOrder(false));
            yield put(getCurrentOrderRequest({ tokenCode: res.tokenCode }));
            yield put(setOrderDetails({
                customerId: res.customerId,
                hotelId: res.hotelIds[0],
                tableId: payload.tableId,
                isFoodCourt: payload.isFoodCourt,
                tokenCode: res.tokenCode,
                tokenId: res.tokenId,
                new: res.new
            }));
            if (payload.isFoodCourt) {
                yield put(setFoodCourtHotelData());
            }

            if (res.new) {
                const codeStr = CryptoJS.AES.decrypt(res.tokenCode, env.cryptoSecret).toString(CryptoJS.enc.Utf8);
                const code = codeStr.split('-').map(c => String.fromCodePoint(c)).join('');
                // const decryptFrameCode = CryptoJS.AES.decrypt(frameCode, env.cryptoSecret).toString(CryptoJS.enc.Utf8);
                document.cookie = `code_token=${res.tokenCode}; max-age=${2 * 60 * 60}; path=/`;
                yield put(setTokenCode({
                    show: true,
                    copied: false,
                    code,
                    tokenId: res.tokenId
                }));
                // yield put(subscribeNotificationRequest({ customerId }));
            }
            yield put(setOrderSuccessAnimation('ENTER'));
            yield delay(2200);
            yield put(setOrderSuccessAnimation('EXIT'));
        }
    } catch (error) {
        console.error('Failed to place order', error);
        yield put(setIsLoading(false));
        toast.error(`Failed to place order ${error.message}`);
    }
}

function* paymentOrderRequestSaga(action) {
    try {
        const payload = action.payload;
        const res = yield checkoutService.paymentRequest({
            hotelIds: payload.hotelIds,
            customerId: payload.customerId,
            foodCourtId: payload.foodCourtId
        });
        localStorage.setItem('orderPaymentData', JSON.stringify({
            hotelId: payload.foodCourtId || payload.hotelIds[0],
            tokenId: payload.tokenId,
            tokenCode: payload.tokenCode,
            isFoodCourt: Boolean(payload.foodCourtId),
            type: payload.type,
            new: payload.new,
            tableId: payload.tableId,
            // frameCode: payload.frameCode,
            customerId: payload.customerId
        }));

        yield put(setOrderPaymentData(res));
    } catch (error) {
        console.error('Failed to process payment request', error);
        toast.error(`Failed to process payment request ${error.message}`);
    }
}

function* paymentSuccessRequestSaga() {
    try {
        const payload = localStorage.getItem('orderPaymentData') ? JSON.parse(localStorage.getItem('orderPaymentData')) : {};
        localStorage.removeItem('orderPaymentData');

        const {
            hotelId,
            tokenId,
            tokenCode,
            isFoodCourt,
            type,
            new: newOrder,
            // frameCode,
            customerId,
            tableId
        } = payload;

        if (type === BILLING_TYPE[0].value) {
            toast.success(`Order placed successfully! Your order is being prepared.`);
            // yield put(getMenuDetailsRequest({
            //     hotelId,
            //     tokenCode,
            //     foodCourt: isFoodCourt
            // }));
            yield put(getCurrentOrderRequest({ tokenCode }));
            yield put(setOrderDetails({
                customerId,
                hotelId,
                tableId,
                isFoodCourt,
                tokenCode,
                tokenId,
                new: newOrder
                // frameCode
            }));

            if (newOrder) {
                const codeStr = CryptoJS.AES.decrypt(tokenCode, env.cryptoSecret).toString(CryptoJS.enc.Utf8);
                const code = codeStr.split('-').map(c => String.fromCodePoint(c)).join('');
                // const decryptFrameCode = CryptoJS.AES.decrypt(frameCode, env.cryptoSecret).toString(CryptoJS.enc.Utf8);
                document.cookie = `code_token=${tokenCode}; max-age=${2 * 60 * 60}; path=/`;
                yield put(setTokenCode({ show: true, copied: false, code, tokenId }));
                // yield put(subscribeNotificationRequest({ customerId }));
            }
        } else {
            // toast.success(`Payment successful!`);
            // // if (!customerData?.customerView) {
            // //     yield put(getActiveOrders({ hotelId }));
            // //     yield put(updateShowMenuCard(false));
            // // }
            // yield put(setFeedback({
            //     data: {
            //         customerId: payload.customerId,
            //         tokenId,
            //         adminView: !customerData?.customerView,
            //         hotelId
            //     },
            //     show: true
            // }));
            // localStorage.removeItem('newCheck');
        }
        yield put(setShowOrder(false));
        yield put(setOrderPaymentData(false));
        yield put(setCustomerOrder({ show: false, data: {}, bill: {} }));
    } catch (error) {
        console.error('Failed to update order status on payment success', error);
        toast.error(`Failed to confirm payment ${error.message}`);
    }
}

// function* paymentFailedRequestSaga(action) {
//     try {
//         const payload = action.payload;
//         yield checkoutService.paymentFailed(payload);
//         yield put(setOrderPaymentData(false));
//     } catch (error) {
//         console.error('Failed to update order status on payment success', error);
//         toast.error(`Failed to confirm payment ${error.message}`);
//     }
// }

function* sendFeedbackRequestSaga(action) {
    try {
        const { hotelId, ...payload } = action.payload;
        const response = yield orderService.feedback(payload);

        let isJson = false;
        try {
            JSON.parse(new TextDecoder().decode(response));
            isJson = true;
        } catch (e) {
            isJson = false;
        }

        if (!isJson) {
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const pdf = document.createElement('a');
            pdf.href = url;
            pdf.download = 'invoice.pdf';
            document.body.appendChild(pdf);
            pdf.click();
            pdf.remove();
            window.URL.revokeObjectURL(url);
        }

        // if (adminView) {
        //     // yield put(getActiveOrders({ hotelId }));
        //     yield put(setFeedback({ show: false, data: {} }));
        //     // yield put(setAdditionalActions({ show: false }));

        //     toast.success('Feedback has been submitted successfully');
        // } else {
        yield put(setFeedback({ show: true, done: true }));

        Cookies.remove('code_token');
        localStorage.removeItem('newCheck');
        // }
    } catch (error) {
        console.error('Failed to process feedback request', error);
        toast.error(`Failed to submit feedback ${error.message}`);
    }
}

function* notifyManagersRequestSaga(action) {
    try {
        const payload = action.payload;
        yield service.notifyUsers(payload);
        toast.success('Your request has been sent. A manager will reach you soon.');
    } catch (error) {
        console.error('Failed to notify manager', error);
        toast.error(`Failed to notify order managers${error.message}`);
    }
}

function* getCurrentOrderRequestSaga(action) {
    const { tokenCode, feedback } = action.payload;
    try {
        const res = yield service.getCurrentOrder(tokenCode);
        yield put(setCurrentOrder(res));

        if (feedback?.check) {
            const check = res.data.some(o => [ORDER_STATUS.pending, ORDER_STATUS.prepared].includes(String(o.status).toUpperCase()));
            if (check) {
                toast.warn('Cannot proceed since there some unserved orders');
            } else {
                const { customerId, tokenId } = feedback;
                yield put(setFeedback({
                    data: { customerId, tokenId },
                    show: true
                }));
            }
        }
    } catch (error) {
        console.error('Failed to fetch current order details', error);
        if (error.message === 'INVALID_TOKEN') {
            if (feedback?.check) {
                const { customerId, tokenId } = feedback;
                yield put(setFeedback({
                    data: { customerId, tokenId },
                    show: true
                }));
            } else {
                Cookies.remove('code_token');
                yield put(resetStateRequest());
            }
        } else {
            toast.error(`Failed to fetch current order details ${error.message}`);
        }
    }
}

export default function* orderPlacementSaga() {
    yield all([takeLatest(GET_MENU_DETAIL_REQUEST, getMenuDetailsRequestSaga)]);
    yield all([takeLatest(PLACE_ORDER_REQUEST, placeOrderRequestSaga)]);
    yield all([takeLatest(PAY_ORDER_REQUEST, paymentOrderRequestSaga)]);
    yield all([takeLatest(PAY_SUCCESS_REQUEST, paymentSuccessRequestSaga)]);
    // yield all([takeLatest(PAY_FAILURE_REQUEST, paymentFailedRequestSaga)]);
    yield all([takeLatest(SEND_FEEDBACK_REQUEST, sendFeedbackRequestSaga)]);
    yield all([takeLatest(NOTIFY_MANAGERS_REQUEST, notifyManagersRequestSaga)]);
    yield all([takeLatest(GET_CURRENT_ORDER_REQUEST, getCurrentOrderRequestSaga)]);
}
